import fetch from 'isomorphic-fetch';
import { toastr } from 'react-redux-toastr';

import { createReducer, responseOkay } from '../utils';

export const FETCH = 'property/FETCH';
export const FETCH_SUCCESS = 'property/FETCH_SUCCESS';
export const FETCH_ERROR = 'property/FETCH_ERROR';
export const MAKE_OFFER = 'property/MAKE_OFFER';
export const MAKE_OFFER_SUCCESS = 'property/MAKE_OFFER_SUCCESS';
export const MAKE_OFFER_ERROR = 'property/MAKE_OFFER_ERROR';
export const OFFERS_RECEIVED = 'property/OFFERS_RECEIVED';
export const ENDING_UPDATED = 'property/ENDING_UPDATED';
export const STARTED = 'property/STARTED';
export const ENDED = 'property/ENDED';
export const FETCH_LAST_OFFER = 'property/FETCH_LAST_OFFER';
export const FETCH_LAST_OFFER_SUCCESS = 'property/FETCH_LAST_OFFER_SUCCESS';
export const FETCH_LAST_OFFER_ERROR = 'property/FETCH_LAST_OFFER_ERROR';

const initialState = {
  data: null,
  fetching: false,
  isError: false,
  lastOffer: '',
};

export function offersReceived(hashId, payload) {
  return (dispatch, getState) => {
    const { data } = getState().property;
    if ( data && data.hashId && data.hashId === hashId) {
      dispatch({ type: OFFERS_RECEIVED, payload });
    }
  }
};

export function endingUpdated(hashId, payload) {
  return (dispatch, getState) => {
    const { data } = getState().property;
    if ( data && data.hashId && data.hashId === hashId) {
      dispatch({ type: ENDING_UPDATED, payload });
    }
  }
};

export function propertyStarted(hashId, payload) {
  return (dispatch, getState) => {
    const { data } = getState().property;
    if ( data && data.hashId && data.hashId === hashId) {
      dispatch({ type: STARTED, payload });
    }
  }
};

export function propertyEnded(hashId, payload) {
  return (dispatch, getState) => {
    const { data } = getState().property;
    if ( data && data.hashId && data.hashId === hashId) {
      dispatch({ type: ENDED, payload });
    }
  }
};

export function fetchLastOffer(token, hashId) {
  return (dispatch) => {
    dispatch({ type: FETCH_LAST_OFFER });

    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    if (token) {
      options.headers['Authorization'] = `Bearer ${token}`;
     }

    return fetch(`/api/property/${hashId}/lastOffer`, options)
      .then(responseOkay)
      .then(response => response.json())
      .then(payload => dispatch({ type: FETCH_LAST_OFFER_SUCCESS, payload }))
      .catch(error => dispatch({ type: FETCH_LAST_OFFER_ERROR }))
  };
};

export function fetchProperty(token, hashId) {
  return (dispatch) => {
    dispatch({ type: FETCH });
     const options = {
       method: 'GET',
       headers: {
        'Content-Type': 'application/json',
      },
     };

     if (token) {
      options.headers['Authorization'] = `Bearer ${token}`;
     }

     return fetch(`/api/property/${hashId}`, options)
      .then(response => response.json())
      .then(payload => dispatch({ type: FETCH_SUCCESS, payload}))
      .catch(error => FETCH_ERROR);
  };
}

export function makeOffer(token, hashId, amount) {
  return (dispatch, getState) => {
    dispatch({ type: MAKE_OFFER });
    
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        amount,
      }),
    };

    if (token) {
      options.headers['Authorization'] = `Bearer ${token}`;
     }

    return fetch(`/api/offer/${hashId}`, options)
      .then(responseOkay)
      .then(() => {
        toastr.light('Thank you', 'We are considering your offer', {
          icon: 'success',
          status: 'success',
        });
        dispatch({
          type: MAKE_OFFER_SUCCESS,
          payload: amount
        });
       })
      .catch(error => {
        toastr.light('Thank you', 'We will be considering all offers in due course', {
          icon: 'info',
          status: 'info',
        });
        dispatch({
          type: MAKE_OFFER_ERROR,
          payload: error
        });
      });
  }
}

export default createReducer(initialState, {
  [FETCH]: state => ({
    ...state,
    fetching: true,
    isError: false,
  }),
  [FETCH_SUCCESS]: (state, payload) => ({
    ...state,
    data: payload,
    fetching: false,
    isError: false,
  }),
  [FETCH_ERROR]: (state, payload) => ({
    ...state,
    fetching: false,
    isError: true,
  }),
  [OFFERS_RECEIVED]: (state, payload) => ({
    ...state,
    data: {
      ...state.data,
      offers: [
        ...payload,
        ...state.data.offers,
      ],
    },
  }),
  [ENDING_UPDATED]: (state, payload) => ({
    ...state,
    data: {
      ...state.data,
      ...payload,
    }
  }),
  [FETCH_LAST_OFFER_SUCCESS]: (state, payload) => ({
    ...state,
    lastOffer: payload.amount.toString(),
  }),
  [FETCH_LAST_OFFER_ERROR]: (state, payload) => ({
    ...state,
    lastOffer: initialState.lastOffer,
  }),
  [MAKE_OFFER_SUCCESS]: (state, payload) => ({
    ...state,
    lastOffer: payload,
  }),
  [STARTED]: (state, payload) => ({
    ...state,
    data: {
      ...state.data,
      ...payload,
    }
  }),
  [ENDED]: (state, payload) => ({
    ...state,
    data: {
      ...state.data,
      ...payload,
    }
  }),
});



// WEBPACK FOOTER //
// ./src/redux/property.js